import styled from '@emotion/styled'

import { skeletonLoading } from '@/styles/emotion.config'

export const Skeleton = styled.div<{
  image?: boolean
  text?: boolean
  width?: string
  height?: string
  margin?: string
}>((props) => ({
  animation: `${skeletonLoading} 1s linear infinite alternate`,
  height: props.height || '0.75rem',
  width: props.width || '100%',

  ...(props.text && {
    borderRadius: '0.5rem',
    marginBottom: '1rem',
  }),

  ...(props.margin && { margin: props.margin }),
}))
